export const linkRegex = () => new RegExp("^https?://")
